import template from './adpPinIcon.html';
import controller from './adpPinIcon.controller';
import './adpPinIcon.less';

let adpPinIconComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default adpPinIconComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpPinIcon/adpPinIcon.component.js